import { render, staticRenderFns } from "./Scrollup.vue?vue&type=template&id=224ef4e0&"
import script from "./Scrollup.vue?vue&type=script&lang=js&"
export * from "./Scrollup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports